module.exports = __webpack_public_path__ + "img/logo-dark.43389fe8.png";